import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { adminApi, saveAdminSession } from "@/lib/adminApi";

/** Handles {origin}/admin/inbox#session_id=... after Emergent Google auth. */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/admin", { replace: true }); return; }
    adminApi.post("/auth/session", { session_id: sessionId })
      .then((r) => {
        saveAdminSession(r.data.session_token);
        window.history.replaceState(null, "", location.pathname);
        navigate("/admin/inbox", { replace: true, state: { user: r.data } });
      })
      .catch(() => navigate("/admin", { replace: true, state: { error: "Sign-in failed. Please try again." } }));
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#070A0F] flex items-center justify-center" data-testid="auth-callback">
      <p className="font-coords text-[10px] tracking-[0.4em] text-[#D4AF37]">SIGNING IN…</p>
    </div>
  );
}
